import styled from 'styled-components';




export const btnStyle = `
  color: red;
`

export const AppWrapper = styled.div`
  display: block;
`

export const MainWrapper = styled.main`
  text-align: center;

  /* #about {
    background-color: #FFFAFF;
  }

  #services {
    background-color: #C2C1C2;
  } */

`

export const headerSecStyled = `
    font-weight: 500;
`

export const flexColWrap = `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

`

export const flexRowWrap =  `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

`

export const borderStyle = `
    border: 2px solid black;
`


export const DividerLine = styled.div`
  border: 0;
  height: 15px;
  margin: 0 auto;
  margin-top: 30px !important;
  margin-bottom: 30px !important;
  position: relative;
  background: radial-gradient(ellipse at bottom, rgba(0,0,0,0.1) 0%,rgba(0,0,0,0) 70%);
  width: 70% !important;
`

export const MainHeader = styled.div`
  margin-top: 30px;
  font-size: 12px;
  text-transform: uppercase;
  line-height: 1.4;
  font-weight: 400;
  margin-bottom: 2.69rem;
  letter-spacing: 3px;
`

export const PrimaryHeader = styled.h2`
  color: #113C48;
  font-weight: 900;
  line-height: 1.4;
  margin-bottom: 2.233rem;
`

